import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-no-data-found',
  standalone: true,
  imports: [CommonModule, LottieComponent],
  templateUrl: './no-data-found.component.html',
  styleUrl: './no-data-found.component.css',
})
export class NoDataFoundComponent {
  constructor() {}

  options: AnimationOptions = {
    path: 'assets/Animations/No data found.json',
    loop: true,
    autoplay: true,
  };
}
